<div class="impersonation-wrapper">
  <div class="user-info">
    <i class="bi bi-person-circle user-icon"></i>
    <div class="user-text">
      <p class="user-name">{{ userName }}</p>
      <p class="user-email">{{ userEmail }}</p>
    </div>
  </div>

  <button class="return-button" (click)="returnToProfile()">
    {{ 'buttons.back_to_my_profile' | translate }}
  </button>
</div>
